module.exports = __webpack_public_path__ + "media/images/jpd-logo-09b5f55a72b812df96bc70206184770a.png";